module.exports = __webpack_public_path__ + "img/location-off-red.1a553b21.svg";